/**
 * Screen Wake Lock implementation for Shiffa.in
 * Keeps the screen awake when user is browsing the site.
 */

(function() {
  if (!('wakeLock' in navigator)) {
    console.log('Screen Wake Lock API is not supported in this browser.');
    return;
  }

  let wakeLock = null;

  async function requestWakeLock() {
    // If wakeLock is already active or document is not visible, don't request
    if (wakeLock !== null || document.visibilityState !== 'visible') {
      return;
    }

    try {
      wakeLock = await navigator.wakeLock.request('screen');
      
      wakeLock.addEventListener('release', () => {
        wakeLock = null;
        console.log('Wake Lock was released.');
      });

      console.log('Wake Lock is active.');
    } catch (err) {
      console.warn(`Could not acquire Wake Lock: ${err.name}, ${err.message}`);
      wakeLock = null;
    }
  }

  // Handle visibility changes (re-acquire when returning to tab)
  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      await requestWakeLock();
    } else {
      wakeLock = null;
    }
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Request when window is focused
  window.addEventListener('focus', async () => {
    await requestWakeLock();
  });

  // Request when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestWakeLock);
  } else {
    requestWakeLock();
  }

  // Fallback: try requesting on first user interaction if not already acquired
  const requestOnInteraction = async () => {
    if (!wakeLock) {
      await requestWakeLock();
    }
    // Remove interaction listeners to avoid redundant calls
    ['click', 'touchstart', 'scroll'].forEach(event => {
      document.removeEventListener(event, requestOnInteraction);
    });
  };

  ['click', 'touchstart', 'scroll'].forEach(event => {
    document.addEventListener(event, requestOnInteraction, { passive: true });
  });
})();
